import { OutlinedInput, OutlinedInputProps } from '@mui/material'
import React from 'react'

const OutlinedInputWrapper: React.FC<OutlinedInputProps> = ({ ...props }) => (
  <OutlinedInput {...props} />
);

export default OutlinedInputWrapper
